type GetAuthorFairValueLabelProps = {
  displayName: string | null;
  narrativeType: 'AI' | 'FAIR_VALUE' | 'LEGACY' | 'USER' | 'WARREN' | null;
};
export const getAuthorFairValueLabel = ({
  displayName,
  narrativeType,
}: GetAuthorFairValueLabelProps) => {
  if (narrativeType === 'AI') return `${displayName || 'User'} Fair Value`;
  return `${displayName || 'Simply Wall St User'}'s Fair Value`;
};
